import { scopedStorageKey } from "@/lib/storageScope";
import { branchIdentifier } from "@/lib/fulfillment";
import type { ActiveBranch } from "./branch";

export const SELECTED_BRANCH_EVENT = "tappya:selected-branch";
const SELECTED_BRANCH_STORAGE_KEY = "v2_selected_branch_id";
const SELECTED_BRANCH_SNAPSHOT_STORAGE_KEY = "v2_selected_branch_snapshot";

function selectedBranchIdKey(slug?: string | null): string {
  return scopedStorageKey(SELECTED_BRANCH_STORAGE_KEY, slug);
}

function selectedBranchSnapshotKey(slug?: string | null): string {
  return scopedStorageKey(SELECTED_BRANCH_SNAPSHOT_STORAGE_KEY, slug);
}

export function readSelectedBranchId(slug?: string | null): string | null {
  if (typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(selectedBranchIdKey(slug));
  } catch {
    return null;
  }
}

export function readSelectedBranchSnapshot(slug?: string | null): ActiveBranch | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(selectedBranchSnapshotKey(slug));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ActiveBranch;
    return branchIdentifier(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function persistSelectedBranchId(
  branchId: string | null,
  branch?: ActiveBranch | null,
  slug?: string | null,
): void {
  if (typeof window === "undefined") return;
  try {
    const idKey = selectedBranchIdKey(slug);
    const snapshotKey = selectedBranchSnapshotKey(slug);
    if (branchId) {
      sessionStorage.setItem(idKey, branchId);
      if (branch && branchIdentifier(branch) === branchId) {
        sessionStorage.setItem(
          snapshotKey,
          JSON.stringify(branch),
        );
      } else {
        sessionStorage.removeItem(snapshotKey);
      }
    } else {
      sessionStorage.removeItem(idKey);
      sessionStorage.removeItem(snapshotKey);
    }
  } catch {
    /* storage unavailable */
  }
  window.dispatchEvent(
    new CustomEvent(SELECTED_BRANCH_EVENT, { detail: { branchId, slug } }),
  );
}
